import gql from 'graphql-tag'

export const weeklyTimeScheduleCreate = gql`
  mutation weeklyTimeScheduleCreate($input: WeeklyTimeScheduleCreateInput!) {
    weeklyTimeScheduleCreate(input: $input) {
      weeklyTimeSchedule {
        id
        name
        weeklySchedule {
          days
          dailySchedule {
            id
          }
        }
        isGlobal
        isUsed
      }
    }
  }
`

export const weeklyTimeScheduleUpdate = gql`
  mutation weeklyTimeScheduleUpdate($input: WeeklyTimeScheduleUpdateInput!) {
    weeklyTimeScheduleUpdate(input: $input) {
      success
    }
  }
`

export const weeklyTimeScheduleDelete = gql`
  mutation weeklyTimeScheduleDelete($weeklyScheduleId: ID!) {
    weeklyTimeScheduleDelete(input: { weeklyScheduleId: $weeklyScheduleId }) {
      deletedId
    }
  }
`

export const weeklyTimeSchedulesReset = gql`
  mutation weeklyTimeSchedulesReset($deviceId: ID!) {
    weeklyTimeSchedulesReset(input: { deviceId: $deviceId }) {
      success
      device {
        dailyTimeSchedules {
          id
          name
          schedule
          isGlobal
          isUsed
        }
        weeklyTimeSchedules {
          id
          name
          weeklySchedule {
            days
            dailySchedule {
              id
            }
          }
          isGlobal
        }
        activeTimeSchedule {
          id
          name
          weeklySchedule {
            days
            dailySchedule {
              id
            }
          }
        }
      }
    }
  }
`
